import { useState } from "react";
import { PageHeader } from "@/components/shared/PageHeader";
import { Filters, EMPTY_FILTERS, toParams } from "@/components/work/Filters";
import { ItemRow } from "@/components/work/ItemRow";
import { Kanban } from "@/components/work/Kanban";
import { CalendarView } from "@/components/work/CalendarView";
import { BulkBar } from "@/components/work/BulkBar";
import { ItemPanelHost } from "@/components/work/ItemPanel";
import { useItems, useBoards } from "@/lib/work";

export default function AllWork() {
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [layout, setLayout] = useState("list");
  const [sel, setSel] = useState([]);
  const [showArchived, setShowArchived] = useState(false);
  const { boards } = useBoards();
  const { items, reload } = useItems({ ...toParams(filters), include_archived: showArchived || undefined, top_level: undefined }, [JSON.stringify(filters), showArchived]);
  const boardName = (id) => boards.find((b) => b.id === id)?.name;
  const toggle = (id) => setSel((s) => s.includes(id) ? s.filter((x) => x !== id) : [...s, id]);
  const byBoard = {};
  (items || []).forEach((t) => (byBoard[t.board_id || "_"] ||= []).push(t));
  return (
    <div data-testid="all-work">
      <PageHeader title="All work" subtitle="Every task, issue and request you can see — grouped by board.">
        <label className="text-xs text-slate-500 flex items-center gap-1.5"><input type="checkbox" checked={showArchived} onChange={(e) => setShowArchived(e.target.checked)} data-testid="all-show-archived" /> Show archived</label>
      </PageHeader>
      <Filters filters={filters} setFilters={setFilters} layout={layout} setLayout={setLayout} />
      {!items ? <p className="text-slate-400 text-sm">Loading…</p> : items.length === 0 ? <div className="panel p-10 text-center text-slate-400 text-sm">Nothing matches these filters.</div>
        : layout === "kanban" ? <Kanban items={items} onChanged={reload} />
        : layout === "calendar" ? <CalendarView items={items} onChanged={reload} />
        : <div className="space-y-4">{Object.entries(byBoard).sort(([a], [b]) => (boardName(a) || "zz").localeCompare(boardName(b) || "zz")).map(([bid, list]) => (
          <div key={bid} className="panel overflow-hidden" data-testid={`all-group-${bid}`}>
            <div className="px-4 py-2 border-b flex items-center justify-between bg-slate-50/60" style={{ borderColor: "var(--line)" }}><span className="text-xs font-semibold text-slate-700">{boardName(bid) || "Personal / unfiled"}</span><span className="text-[11px] text-slate-400 tabular">{list.length}</span></div>
            <div className="divide-y" style={{ borderColor: "var(--line)" }}>{list.map((t) => <ItemRow key={t.id} item={t} onChanged={reload} selected={sel.includes(t.id)} onSelect={toggle} />)}</div>
          </div>))}</div>}
      <BulkBar ids={sel} clear={() => setSel([])} onDone={reload} />
      <ItemPanelHost onChanged={reload} />
    </div>);
}
